import { IBreedItemResponse, IBreedResponse } from ".";
import { useEffect, useState } from "react";

import { IOptionGeneric } from "../../shared/interface";
import { SEARCH_BREEDS } from "./breed.query";
import { useLazyQuery } from "@apollo/client";

export const useBreeds = () => {
  const [breeds, setBreeds] = useState<IOptionGeneric[]>([]);
  const [searchBreeds, { loading, error, data }] = useLazyQuery<{ searchBreeds: IBreedResponse }>(SEARCH_BREEDS);

  const searchBreed = (speciesId: string, input: string) => {
    if (!input) {
      setBreeds([]);
    } else {
      searchBreeds({
        variables: { data: { speciesId, input } },
      });
    }
  };

  useEffect(() => {
    if (data) {
      setBreeds(data ? breedResponseMap(data.searchBreeds.breeds) : []);
    }
  }, [data]);

  return {
    breeds,
    loading,
    error,
    searchBreed,
  };
};

const breedResponseMap = (breeds: IBreedItemResponse[]): IOptionGeneric[] => {
  return breeds.map((breed: IBreedItemResponse) => ({
    value: breed.id,
    label: breed.name,
    species_id: breed.species_id,
  }));
};
